import Box from "@mui/material/Box";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import * as Components from "./ScreenSizeToSmall.components";
import OutputLogo302x44 from "./OutputLogo_302x44.svg";

interface Dimensions {
  height: number;
  width: number;
}

const BREAKPOINT_WIDTH = 960;

function ScreenSizeToSmall() {
  const { t } = useTranslation();

  const [dimensions, setDimensions] = useState<Dimensions>({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const onDimensionChange = useCallback(() => {
    setDimensions({
      height: window.innerHeight,
      width: window.innerWidth,
    });
  }, []);

  useEffect(() => {
    window.addEventListener("resize", onDimensionChange);
    return () => window.removeEventListener("resize", onDimensionChange);
  }, [onDimensionChange]);

  if (dimensions.width > BREAKPOINT_WIDTH) {
    return null;
  }

  return (
    <Components.ContainerBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top={0}
      right={0}
      bottom={0}
      left={0}
    >
      <Box sx={{ textAlign: "center" }}>
        <Box sx={{ pb: 4 }}>
          <img src={OutputLogo302x44} alt={t("global.logo_stripes_alt_text")} />
        </Box>
        <Components.TextBox>{t("global.screen_size_small_warning")}</Components.TextBox>
        <Components.TextBox>{t("global.screen_size_small_suggestion")}</Components.TextBox>
      </Box>
    </Components.ContainerBox>
  );
}

export default ScreenSizeToSmall;
